const TOAST_REGION_ID = 'deroyalty-toast-region';

function getToastRegion() {
  let region = document.getElementById(TOAST_REGION_ID);

  if (!region) {
    region = document.createElement('div');
    region.id = TOAST_REGION_ID;
    region.className = 'deroyalty-toast-region';
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'false');
    document.body.appendChild(region);
  }

  return region;
}

export function showAppToast({ message, type = 'success', duration = 2600 }) {
  if (typeof document === 'undefined' || !message) return null;

  const region = getToastRegion();
  const toast = document.createElement('div');
  const icon = document.createElement('span');
  const iconGlyph = document.createElement('i');
  const text = document.createElement('span');
  const closeButton = document.createElement('button');
  const closeIcon = document.createElement('i');
  const iconClasses = {
    success: 'bi bi-check2-circle',
    error: 'bi bi-exclamation-triangle',
    warning: 'bi bi-exclamation-circle',
    info: 'bi bi-info-circle',
  };

  toast.className = `deroyalty-toast deroyalty-toast--${type}`;
  toast.setAttribute('role', type === 'error' ? 'alert' : 'status');

  icon.className = 'deroyalty-toast-icon';
  icon.setAttribute('aria-hidden', 'true');
  iconGlyph.className = iconClasses[type] || iconClasses.success;
  icon.appendChild(iconGlyph);

  text.className = 'deroyalty-toast-message';
  text.textContent = message;

  closeButton.type = 'button';
  closeButton.className = 'deroyalty-toast-close';
  closeButton.setAttribute('aria-label', 'Dismiss notification');
  closeIcon.className = 'bi bi-x-lg';
  closeIcon.setAttribute('aria-hidden', 'true');
  closeButton.appendChild(closeIcon);

  toast.appendChild(icon);
  toast.appendChild(text);
  toast.appendChild(closeButton);
  region.appendChild(toast);

  const removeToast = () => {
    if (toast.dataset.dismissed === 'true') return;
    toast.dataset.dismissed = 'true';
    toast.classList.add('is-leaving');
    window.setTimeout(() => {
      toast.remove();
      if (!region.childElementCount) {
        region.remove();
      }
    }, 180);
  };

  closeButton.addEventListener('click', removeToast);

  if (Number.isFinite(duration) && duration > 0) {
    window.setTimeout(removeToast, duration);
  }

  return toast;
}
